import { useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './Navbar.css';
import { CiPower } from "react-icons/ci";

function Navbar() {
  const navigate = useNavigate();
  const toggleButtonRef = useRef(null);
  const offCanvasRef = useRef(null);

  useEffect(() => {
    const toggleButton = toggleButtonRef.current;
    const offCanvas = offCanvasRef.current;

    const handleToggle = () => {
      offCanvas.classList.toggle('show');
    };

    const handleLinkClick = () => {
      offCanvas.classList.remove('show');
      const backdrop = document.querySelector('.offcanvas-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    };

    toggleButton.addEventListener('click', handleToggle);

    const navLinks = offCanvas.querySelectorAll('.nav-link');
    navLinks.forEach(link => {
      link.addEventListener('click', handleLinkClick);
    });

    return () => {
      toggleButton.removeEventListener('click', handleToggle);
      navLinks.forEach(link => {
        link.removeEventListener('click', handleLinkClick);
      });
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container-fluid p-1 mx-5">
        <Link className="navbar-brand" id="logo" to="/dashboard">EMS</Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasNavbar"
          aria-controls="offcanvasNavbar"
          aria-expanded="false"
          aria-label="Toggle navigation"
          ref={toggleButtonRef}
          id='navbar-toggler'
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="offcanvas offcanvas-end "
          tabIndex="-1"
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          ref={offCanvasRef}
        >
          <div className="offcanvas-header">
            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">EMS</h5>
            <button
              type="button"
              className="btn-close text-reset"
              data-bs-dismiss="offcanvas"
              aria-label="Close"
            ></button>
          </div>
          <div className="offcanvas-body">
            <ul className="navbar-nav justify-content-end flex-grow-1 " id="navLinks">
              <li className="nav-item">
                <Link className="nav-link" to="/dashboard">Dashboard</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/employees">Employee List</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/employees/new">Add Employee</Link>
              </li>
              <li className="nav-item">
                <button className="btn btn-link nav-link" onClick={handleLogout}>Logout <CiPower /></button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;